module.exports = __webpack_public_path__ + "img/finish.11bc87a8.jpg";